module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_9.cd901ef5.png";